<template>
  <div>
    <v-app-bar app color="white" hide-on-scroll>
      <router-link to="/">
        <div class="d-flex align-center">
          <v-img
            alt="The Lodge Logo"
            class="mr-2 shrink"
            contain
            src="https://firebasestorage.googleapis.com/v0/b/unichat-ec43c.appspot.com/o/lodge.png?alt=media&token=4c1c28a5-d1c4-4dcf-ab61-0ba2a55e30e5"
            transition="scale-transition"
            width="80"
          />
        </div>
      </router-link>
      <v-toolbar-title>The Lodge</v-toolbar-title>

      <v-spacer></v-spacer>

      <!-- in desktop mode -->
      <div class="d-none d-sm-flex">
        <v-btn class="mr-3 text-capitalize" v-for="item in pageItems" :key="item.title" :to="item.link" depressed plain text>
          {{ item.title }}
        </v-btn>
        <v-btn color="primary" outlined @click="logout">Logout</v-btn>
      </div>

      <div class="d-flex d-sm-none">
        <v-menu left bottom rounded="lg" transition="scale-transition">
          <template v-slot:activator="{ on, attrs }">
            <v-btn icon v-bind="attrs" v-on="on" aria-label="menu">
              <v-icon>mdi-menu</v-icon>
            </v-btn>
          </template>

          <!-- in mobile mode -->
          <v-list>
            <v-list-item v-for="item in pageItems" :key="item.title" :to="item.link">
              <v-list-item-title>{{ item.title }}</v-list-item-title>
            </v-list-item>
            <v-list-item>
              <v-btn text @click="logout"> Logout</v-btn>
            </v-list-item>
          </v-list>
        </v-menu>
      </div>
    </v-app-bar>
  </div>
</template>

<script>
export default {
  data: () => ({
    pageItems: [
      { title: "Members", link: "/" },
      { title: "Cost", link: "/costs" },
    ],
  }),
  methods: {
    logout() {
      this.$store.dispatch("auth/LOGOUT");
    },
  },
};
</script>

<style lang="scss" scoped></style>
